import { uniq } from 'lodash';
import { cartesianProduct } from '$util/basic/cartesianProduct';

/**
 * Returns a unique collection of (make, model, sku) sets
 */
export const makeSkuMakeModelSets = (
  skus: string[],
  cars?: string[] | Map<string, string[]>
): [sku: string, make: string, model: string][] => {
  const makeModels = new Map<string, string[]>();
  if (cars instanceof Map) {
    cars.forEach((models, make) => {
      // strip makeId if it's modelId which starts with makeId
      const cleanModels = uniq(models).map((model) => model.replace(new RegExp(`^${make}-`, 'gi'), ''));
      makeModels.set(make, cleanModels);
    });
  } else if (cars?.length) {
    uniq(cars).forEach((make) => {
      makeModels.set(make, ['*']);
    });
  } else {
    makeModels.set('*', ['*']);
  }

  const sets = Array.from(makeModels.entries()).flatMap(([make, models]) =>
    cartesianProduct<[make: string, model: string, sku: string]>([make], models, uniq(skus))
  );
  return sets;
};
